export default __webpack_public_path__ + "static/media/steam.054e2fc7.png";